import { type CommentTime } from '@air/analytics';

export const getCommentTime = ({
  endTimestamp,
  timestamp,
}: {
  endTimestamp?: number | null;
  timestamp?: number | null;
}): CommentTime => {
  if (typeof endTimestamp === 'number') {
    return 'time_range';
  }

  if (typeof timestamp === 'number') {
    return 'timestamp';
  }

  return 'none';
};
